/**
 * A flag for whether to re-route the existing "loadComponentInIframe" flow to the sourceless world.
 * Considered "true" if the value is set to anything truthy ("1", "true", etc.).
 */
export const fluidRerouteIframeToSourceless = 'fluidRerouteIframeToSourceless';

/**
 * An override to easily switch the the "sourceless iframe inside" code to come from a test location
 * (rather than the URL specified in the "sourcelessIframeBundleUrl" parameter of "loadComponentInSourcelessIframe").
 **/
export const fluidSourcelessIframeUrlOverride = 'fluidSourcelessIframeUrlOverride';

/**
 * An override for loading a special flavor of the "iframe-inside" code
 * (Only relevant if loading the iframe-inside from our CDN, rather than host-served files)
 */
export const fluidSourcelessIframeFlavorOverride = 'fluidSourcelessIframeFlavorOverride';
